/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `video_frame` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class VideoFrameMesg : Mesg {
    public constructor() : super("VideoFrame", Profile.MesgNum.VIDEO_FRAME)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** timestamp, in s. Whole second part of the timestamp */
    public var timestamp: Instant?
        get() = (getFieldValue(TIMESTAMP_FIELD_NUM) as? UInt)?.let { FitDateTime.toInstant(it) }
        set(value) = setFieldValue(TIMESTAMP_FIELD_NUM, value?.let { FitDateTime.toTimestamp(it) })

    /** timestamp_ms, in ms. Millisecond part of the timestamp. */
    public var timestampMs: UShort?
        get() = getFieldValue(TIMESTAMP_MS_FIELD_NUM) as? UShort
        set(value) = setFieldValue(TIMESTAMP_MS_FIELD_NUM, value)

    /** frame_number. Number of the frame that the timestamp and timestamp_ms correlate to */
    public var frameNumber: UInt?
        get() = getFieldValue(FRAME_NUMBER_FIELD_NUM) as? UInt
        set(value) = setFieldValue(FRAME_NUMBER_FIELD_NUM, value)

    public companion object {
        public const val TIMESTAMP_FIELD_NUM: UByte = 253u
        public const val TIMESTAMP_MS_FIELD_NUM: UByte = 0u
        public const val FRAME_NUMBER_FIELD_NUM: UByte = 1u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[253] = Field("Timestamp", 253u, BaseType.UINT32, 1.0, 0.0, "s", false)
            fields[0] = Field("TimestampMs", 0u, BaseType.UINT16, 1.0, 0.0, "ms", false)
            fields[1] = Field("FrameNumber", 1u, BaseType.UINT32, 1.0, 0.0, "", false)
            return fields
        }
    }
}
